import React, { useContext, useMemo } from 'react';
import { ReloadOutlined } from '@ant-design/icons';
import { Button, Empty, Tooltip } from 'antd';

import Auth0RolesPanelContainer from '@totem/components/administration/auth0/roles/panel/Auth0RolesPanelContainer';
import Auth0RolesPanelContext from '@totem/components/administration/auth0/roles/panel/Auth0RolesPanelContext';
import Auth0RolesPanelTable from '@totem/components/administration/auth0/roles/panel/Auth0RolesPanelTable';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';
import { FilterField } from '@totem/components/ui_components/reportSettings/types';
import { Filter } from '@totem/types/common';

const EMPTY_FILTER_CONFIG: FilterField[] = [];

export interface Props {
  buildingId?: string;
  buildingName?: string;
  controlSystemId?: string;
  componentKey?: string;
}

const Auth0RolesPanelBody = () => {
  const { loading, roles, onRefresh } = useContext(Auth0RolesPanelContext);

  return (
    <IBCard
      isCovered
      title="Remote Access Roles"
      extra={
        <Tooltip title="Refresh">
          <Button
            icon={<ReloadOutlined />}
            loading={loading}
            onClick={onRefresh}
          />
        </Tooltip>
      }
    >
      {!loading && roles.length === 0 ? (
        <Empty description="No remote access roles are currently assigned." />
      ) : (
        <Auth0RolesPanelTable />
      )}
    </IBCard>
  );
};

const Auth0RolesPanel = ({
  buildingId,
  buildingName,
  controlSystemId,
  componentKey,
}: Props) => {
  const staticFilters = useMemo(() => {
    const filters: Filter[] = [];

    if (buildingId) {
      filters.push({
        field: 'hierarchyReference.building.id',
        values: [buildingId],
      });
    }
    if (controlSystemId) {
      filters.push({
        field: 'hierarchyReference.controlSystem.id',
        values: [controlSystemId],
      });
    }

    return filters;
  }, [buildingId, controlSystemId]);

  return (
    <InputContainer
      filterConfig={EMPTY_FILTER_CONFIG}
      staticFilters={staticFilters}
      componentKey={componentKey}
    >
      <Auth0RolesPanelContainer
        buildingId={buildingId}
        buildingName={buildingName}
      >
        <Auth0RolesPanelBody />
      </Auth0RolesPanelContainer>
    </InputContainer>
  );
};

export default Auth0RolesPanel;
